import { render, staticRenderFns } from "./PageAppointments.vue?vue&type=template&id=132b8192&"
import script from "./PageAppointments.vue?vue&type=script&lang=ts&"
export * from "./PageAppointments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports